function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMealRounded = function SvgMealRounded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "41px",
    viewBox: "0 0 60 41"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(95.686275%,96.862745%,98.039216%)",
      fillOpacity: 1
    },
    d: "M 6 0.601562 L 54 0.601562 C 56.980469 0.601562 59.398438 3.03125 59.398438 6.03125 L 59.398438 34.96875 C 59.398438 37.96875 56.980469 40.398438 54 40.398438 L 6 40.398438 C 3.019531 40.398438 0.601562 37.96875 0.601562 34.96875 L 0.601562 6.03125 C 0.601562 3.03125 3.019531 0.601562 6 0.601562 Z M 6 0.601562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(78.823529%,81.176471%,86.27451%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 21.777344 11.000762 L 21.777344 24.000191 ",
    transform: "matrix(1.2,0,0,1.205882,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(78.823529%,81.176471%,86.27451%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 23.636068 11.000762 L 23.636068 15.092035 C 23.632812 16.092988 22.822266 16.906059 21.819661 16.909299 C 20.813802 16.906059 20.003255 16.092988 20 15.092035 L 20 11.000762 ",
    transform: "matrix(1.2,0,0,1.205882,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(78.823529%,81.176471%,86.27451%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 26.666667 19.665968 L 28.889974 19.665968 C 29.186198 19.675686 29.475911 19.588224 29.6875 19.423018 C 29.895833 19.257812 30.009766 19.031059 30 18.801067 C 29.879557 16.310023 29.752604 13.702363 27.695312 11.198361 C 27.558594 11.036395 27.304688 10.96189 27.067057 11.016959 C 26.832682 11.072027 26.669922 11.240473 26.666667 11.434832 L 26.666667 24.000191 ",
    transform: "matrix(1.2,0,0,1.205882,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(87.843137%,90.980392%,94.901961%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 5 0.498857 L 45 0.498857 C 47.483724 0.498857 49.498698 2.51372 49.498698 5.001524 L 49.498698 28.998476 C 49.498698 31.48628 47.483724 33.501143 45 33.501143 L 5 33.501143 C 2.516276 33.501143 0.501302 31.48628 0.501302 28.998476 L 0.501302 5.001524 C 0.501302 2.51372 2.516276 0.498857 5 0.498857 Z M 5 0.498857 ",
    transform: "matrix(1.2,0,0,1.205882,0,0)"
  }));
};
export default SvgMealRounded;